import { Trans } from '@lingui/macro'
import APR_CALCULATOR_ABI from 'abis/governance/APRCalculator.json'
import { useAPRCalculatorContract } from 'hooks/useGovernanceContracts'

import ContractWidget from '../components/ContractWidget'
import { SectionTitle } from '../styleds'

export default function APRCalculatorTab() {
  const contract = useAPRCalculatorContract()

  return (
    <>
      <SectionTitle>
        <Trans>APRCalculator Contract (0x...0109)</Trans>
      </SectionTitle>

      <ContractWidget
        title="APRCalculator"
        description="APR calculation contract. Manages base APR, macro factors, RSI bonuses, vesting bonuses, and price-based reward calculations."
        contract={contract}
        abi={APR_CALCULATOR_ABI as any}
        defaultFunction="getBaseAPR"
      />
    </>
  )
}
